
(function(){
  function init(){
    var root=document.getElementById('ve-lp'); if(!root) return;
    root.querySelectorAll('.ve-buybar [data-ve-buy]').forEach(function(btn){btn.textContent='SEND MY VERTIGOEASE →';});
    function visible(element){return element && element.getClientRects().length && element.getBoundingClientRect().height>0;}
    function bundle(){
      var scope=document.querySelector('.product__info-container') || document.getElementById('MainContent');
      if(!scope) return null;
      return Array.from(scope.querySelectorAll('.kaching-bundles__block, kaching-bundles-block, .kaching-bundles__bar-container')).find(visible);
    }
    root.addEventListener('click',async function(e){
      var btn=e.target.closest('[data-ve-buy]'); if(!btn || !root.contains(btn)) return;
      e.preventDefault();
      var target=bundle();
      // Kaching renders asynchronously; resolve the current visible offer, not a hidden installment form.
      for(var attempt=0; !target && attempt<15; attempt++){
        await new Promise(function(resolve){setTimeout(resolve,100);}); target=bundle();
      }
      target=target || document.querySelector('product-form[data-main="true"]') || document.querySelector('.product__info-container');
      if(!target) return;
      var header=document.querySelector('.ve-header');
      var offset=24;
      if(header && ['fixed','sticky'].includes(getComputedStyle(header).position)) offset+=header.getBoundingClientRect().height;
      var y=target.getBoundingClientRect().top+window.pageYOffset-offset;
      window.scrollTo({top:Math.max(0,y),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
